<div class="w-full h-full bg-pattern flex flex-col items-center justify-center">
  <div @fadeInUp class="card overflow-hidden w-full max-w-md">
    <div class="p-6 pb-0 flex flex-col items-center justify-center">
      <div class="fill-current text-center">
        <img class="w-48" src="assets/img/dsc/logo_gamlp.png">
      </div>
    </div>

    <div class="text-center mt-4">
      <h2 class="title m-0">Bienvenido a DSC (v2)</h2>
      <h4 class="body-2 text-secondary m-0">Inicie sesión con sus credenciales.</h4>
    </div>

    <div [formGroup]="form" class="p-6 flex flex-col gap-4">
      <div class="flex flex-col">
        <mat-form-field class="flex-1">
          <mat-label>Username</mat-label>
          <input formControlName="username" matInput required>
          <mat-error *ngIf="form.get('username').hasError('required')">Este campo es requerido</mat-error>
        </mat-form-field>
        <mat-form-field class="flex-1">
          <mat-label>Password</mat-label>
          <input [type]="inputType" formControlName="password" matInput required>
          <button (click)="toggleVisibility()" mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button">
            <mat-icon *ngIf="visible" svgIcon="mat:visibility"></mat-icon>
            <mat-icon *ngIf="!visible" svgIcon="mat:visibility_off"></mat-icon>
          </button>
          <mat-hint>Haga clic en el ojo para alternar la visibilidad.</mat-hint>
          <mat-error *ngIf="form.get('password').hasError('required')">Este campo es requerido</mat-error>
        </mat-form-field>
      </div>
      <button (click)="send()" color="primary" mat-raised-button type="submit">
        INGRESAR
      </button>
      <a (click)="display()" color="" mat-raised-button type="link">
        Display
      </a>
    </div>
  </div>
</div>